import { Colour } from '../Colour/Colour';
import { ColourIndex, ColouringMode, ObjColourManager } from '../Colour/Colourable';
import { PointOps } from "../Graphics/PointOps";
import { Point } from "../Misc/Utils";

export class Circle {
    private path : Path2D = new Path2D();

    private defaultRadius = 5
    private defaultColor = 'grey'
    
    private colorMgr = new ObjColourManager();

    constructor(){
        this.setColour(ColourIndex.Stroke, new Colour({h:80, s:0, v:1})); //white
        this.setColour(ColourIndex.Fill, new Colour({h:199, s:0.3, v:0.5})); //grey
        this.setColouringMode(ColouringMode.FillAndStroke);
    }

    setRadius(radius: number){
        this.defaultRadius = radius;
    }

    /*setColor(circleColor: Colour){
        this.defaultColor = circleColor.getColor();
    }*/

    setColour(index: ColourIndex, colour: Colour): void {
        this.colorMgr.setColour(colour, index);
    }
    setColouringMode(mode: ColouringMode):void{
        this.colorMgr.setColouringMode(mode);
    }

    drawCircle(canvasCtx : CanvasRenderingContext2D, centre : Point){
        this.draw(canvasCtx, centre, this.defaultRadius, '');
    }

    draw(canvasCtx : CanvasRenderingContext2D, centre : Point, radius : number, color: string){
        this.colorMgr.setupCanvas(canvasCtx);
        this.path = this.getPath(centre, radius);
        //canvasCtx.fillStyle = color;
        //canvasCtx.strokeStyle = 'white';
        canvasCtx.fill(this.path);
        canvasCtx.stroke(this.path);
    }

    contains(point : Point, centre : Point, radius : number) : boolean{
        return PointOps.containedInCircle(point, centre, 2*radius);
    }

    private getPath(centre : Point, radius : number) : Path2D{
        var path2d = new Path2D();
        path2d.arc(centre[0], centre[1], radius, 0, 2*Math.PI);
        return path2d;
    }
}